<template>
  <div
    class="modal fade"
    id="changeBorrowType"
    tabindex="-1"
    role="dialog"
    aria-labelledby="changeBorrowTypeLabel"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            ref="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
            class="modal-title"
            id="changeBorrowTypeLabel"
          >
            {{ $t('string.changeBorrowType') }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div
                class="form-group"
                :class="{'has-error' : validations.hasOwnProperty('type')}"
              >
                <label class="required">{{ $t('fields.loanType') }}</label>
                <select
                  class="form-control"
                  v-model="borrowType"
                >
                  <option value="Payday">
                    {{ $t('label.payday') }}
                  </option>
                  <option value="Personal">
                    {{ $t('label.personal') }}
                  </option>
                  <option value="Purchasing">
                    {{ $t('label.installment') }}
                  </option>
                  <option value="Pawn">
                    {{ $t('label.pawn') }}
                  </option>
                </select>
                <template v-if="validations.hasOwnProperty('type')">
                  <span class="label-error">{{ validations['type'][0] }}</span>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            :disabled="isLoading"
            @click="close"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
          <button-async-loading
            @click="onUpdate"
            :title="$t('button.update')"
            :is-loading="isLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ButtonAsyncLoading from '@/views/borrows/_components/ButtonAsyncLoading'

export default {
  name: 'ChangeBorrowTypeModal',
  components: { ButtonAsyncLoading },
  data () {
    return {
      validations: {},
      isLoading: false,
      borrowType: null,
      borrowId: null
    }
  },
  computed: {
    ...mapState({
      id: state => state.changeBorrowType.id,
      type: state => state.changeBorrowType.type
    })
  },
  watch: {
    type () {
      this.borrowType = this.type
    },
    id () {
      this.borrowId = this.id
    }
  },
  methods: {
    close () {
      this.$refs.close.click()
    },
    onUpdate () {
      if (!this.borrowType) {
        this.$set(this.validations, 'type', [
          'The type field is required'
        ])
        return 0
      }
      this.isLoading = true
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/change-borrow-type', {
        id: this.borrowId,
        type: this.borrowType
      }).then(() => {
        this.close()
        this.$router.back()
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.isLoading = false
      })
    }
  },
  mounted () {
    this.borrowId = this.id
    this.borrowType = this.type
  }
}
</script>

<style scoped>

</style>
